import styled from 'styled-components';
import React, { FC } from 'react';
import { SkeletonProps } from './models';
import * as styles from './styles';

export const Skeleton = styled<FC<SkeletonProps>>(({ className, children }) => (
  <div {...{ className, 'data-testid': 'skeleton' }}>{children}</div>
))`
  ${styles.Skeleton}
`;
